import data from "../../../../../src/Link/Link.docs.json";
import * as React from 'react';
export default {
  data,
  React
};